const windowWidth = window.matchMedia("(max-width: 56em)");

// lazy load images
const lazyImages = document.querySelectorAll("[data-src]");

const preloadImage = (img) => {
  const src = img.getAttribute("data-src");
  if (!src) {
    return;
  }
  img.src = src;
};

const lazyImgObserver = new IntersectionObserver((entries, lazyImgObserver) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      return;
    } else {
      preloadImage(entry.target);
      lazyImgObserver.unobserve(entry.target);
    }
  });
});

lazyImages.forEach((image) => {
  lazyImgObserver.observe(image);
});

// header js

// Get all navigation items that have submenus
function handleNavResize() {
  const navItems = document.querySelectorAll(".nav-list.has-submenu");

  navItems.forEach((item) => {
    const submenu = document.querySelector(".submenu"); // Corrected line

    if (windowWidth.matches) {
      item.addEventListener("click", function (event) {
        submenu.classList.toggle("open");
      });
    } else {
      item.addEventListener("mouseenter", function () {
        submenu.classList.add("open");
      });
      submenu.addEventListener("mouseleave", function () {
        setTimeout(() => {
          submenu.classList.remove("open");
        }, 100);
      });
    }
  });
}

// Add event listener for window resize
window.addEventListener("DOMContentLoaded", handleNavResize);
window.addEventListener("resize", handleNavResize);

// click event for mobile

// navigation js for responsive

const navToggle = document.querySelector(".hamburgurMenu");
const navWrapper = document.querySelector(".nav-wrapper");

navToggle.addEventListener("click", function () {
  navToggle.classList.toggle("active");
  navWrapper.classList.toggle("active");
  document.body.classList.toggle("scrollStop");
});

// gsap animation

// hero section animation

var tl = gsap.timeline();

tl.from(".hero-section h1", {
  y: 0,
  opacity: 0,
  duration: 0.5,
  delay: 0.2,
  ease: "power2.inOut",
});

tl.from(
  ".hero-section .p-caption",
  {
    y: -50,
    opacity: 0,
    duration: 1,
    delay: 0,
    ease: "power2.inOut",
  },
  "-=0.5"
);

tl.from(
  ".hero-section .p-lg, .hero-section .p-xl, .heroCTA-wrapper",
  {
    y: 50,
    opacity: 0,
    duration: 1,
    delay: 0,
    stagger: 0.1,
    ease: "power2.inOut",
  },
  "-=0.5"
);

gsap.from(".ourProcessDetail-wrapper", {
  y: 80,
  opacity: 0,
  duration: 0.5,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".ourProcessDetail-wrapper",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});

gsap.from(".missionVision-wrapper h2, .missionVision-wrapper p, .btn-wrapper", {
  y: 50,
  opacity: 0,
  duration: 0.4,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".missionVision-wrapper",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});

gsap.from(".ceo-wrapper h2, .ceoImage-wrapper", {
  y: 50,
  opacity: 0,
  duration: 0.4,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".ceo-wrapper",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});

gsap.from(
  ".whyKainest-wrapper h2, .whyKainestItem-wrapper, .whatWeOffer-item",
  {
    y: 50,
    opacity: 0,
    duration: 0.4,
    delay: 0,
    stagger: 0.2,
    scrollTrigger: {
      trigger: ".whyKainest-wrapper",
      scroller: "body",
      markers: false,
      start: "top 80%",
    },
  }
);

gsap.from(".contactUs-wrapper h2, .contactUs-wrapper p", {
  y: 50,
  opacity: 0,
  duration: 0.4,
  delay: 0,
  stagger: 0.2,
  scrollTrigger: {
    trigger: ".contactUs-section",
    scroller: "body",
    markers: false,
    start: "top 80%",
  },
});

// ourProcessDetail js
let question = document.getElementsByClassName("ourProcessItemHeading-wrapper");
for (let i = 0; i < question.length; i++) {
  question[i].addEventListener("click", toggleItem, false);
}

function toggleItem() {
  if (windowWidth.matches) {
    const currentItem = this.parentNode;
    currentItem.classList.toggle("active");

    let allAccItems = document.getElementsByClassName("ourProcessItem-wrapper");
    for (let i = 0; i < allAccItems.length; i++) {
      if (allAccItems[i] !== currentItem) {
        allAccItems[i].classList.remove("active");
      }
    }

    currentItem.scrollIntoView({ behavior: "smooth", block: "start" });
  } else {
    this.parentNode.classList.toggle("active");

    // gsap.from(
    //   ".ourProcessItemContent-wrapper h2, .ourProcessItemContent-wrapper p",
    //   {
    //     y: 50,
    //     opacity: 0,
    //     duration: 0.5,
    //     delay: 0,
    //   }
    // );

    // gsap.from(".ourProcessItemImage img", {
    //   y: 50,
    //   opacity: 1,
    //   duration: 0.5,
    //   delay: 0,
    // });

    let allAccItems = document.getElementsByClassName("ourProcessItem-wrapper");
    for (let i = 0; i < allAccItems.length; i++) {
      if (allAccItems[i] !== this.parentNode) {
        allAccItems[i].classList.remove("active");
      }
    }
  }
}

// glowing cards

// Select all glowing-cards containers
const cards = document.querySelectorAll(".card");

// Loop through each card
cards.forEach((card) => {
  // Add mousemove listener to this specific card
  card.addEventListener("mousemove", (e) => {
    cards.forEach((card) => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      card.style.setProperty("--x", `${x}px`);
      card.style.setProperty("--y", `${y}px`);
    });
  });
});

// copy to clipboard

const dialog = document.querySelector(".copy-link");
const showBtn = document.querySelectorAll(".copy-linkBtn");

showBtn.forEach((btn) => {
  btn.addEventListener("click", () => {
    dialog.classList.add("active");
  });
});

setInterval(() => {
  if (dialog) {
    dialog.classList.remove("active");
  }
}, 2500);

// scroll to top

const scrollToTopBtn = document.getElementById("scrollToTopBtn");

// When the user scrolls the page, execute this function
window.onscroll = function () {
  if (
    document.body.scrollTop > document.body.scrollHeight / 3 ||
    document.documentElement.scrollTop >
    document.documentElement.scrollHeight / 3
  ) {
    scrollToTopBtn.style.display = "block"; // Show button
  } else {
    scrollToTopBtn.style.display = "none"; // Hide button
  }
};

// Scroll to the top of the page when the button is clicked
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // Smooth scrolling
  });
}

scrollToTopBtn.addEventListener("click", scrollToTop);
